import { useValidationYupSenha } from 'utils/form-validations';
import * as Yup from 'yup';
export const useFormLoginValidation = () => {
  const { senhaYup } = useValidationYupSenha();
  const FormLoginYupValidation = Yup.object().shape({
    usuario: Yup.string()
      .required('Email ou apelido é obrigatório.')
      .min(3, 'Deve conter no mínimo 3 caracteres.'),
    senha: senhaYup()
  });

  return {
    FormLoginYupValidation
  };
};
